var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaixaAbertaCor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ffc20e;}.cls-4{fill:#ffd400;}.cls-5{fill:#cd992b;}.cls-6{fill:#a65718;}.cls-7{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}.cls-8{fill:#efaf0f;}.cls-9{fill:#fff;fill-opacity:0;opacity:0;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.12,69.13,44.23,82a8,8,0,0,0,7.54,0L75.89,69.07A4,4,0,0,0,78,65.54V30.4a4,4,0,0,0-2.12-3.53L49.88,13a4,4,0,0,0-3.76,0l-26,13.87A4,4,0,0,0,18,30.4V65.6A4,4,0,0,0,20.12,69.13Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "caixa-aberta-cor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\xCDcones_Personalizados",
    "data-name": "\\xCDcones Personalizados"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caixa-aberta"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48 83.99 48 44 78 28 78 67.94 48 83.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "48 84 48 44.01 18 28.01 18 67.94 48 84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "18 28.01 48 44 78 28 48 12 18 28.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "18 28.01 48 12.01 48 44 18 28.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.38,44.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,44,40,56.83a4,4,0,0,1-5.27,1.41L11.78,46a4,4,0,0,1-1.51-5.65L18,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M48,44l8,12.83a4,4,0,0,0,5.27,1.41L84.22,46a4,4,0,0,0,1.51-5.65L78,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18,28"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 96,
    height: 96
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaixaAbertaCor);
export default __webpack_public_path__ + "static/media/caixa-aberta-cor.a0c7c0df328a5cfa27b6d8d1b1d6f35d.svg";
export { ForwardRef as ReactComponent };